import { Box, Card, Typography } from "@mui/material";
import { Form, Formik, FormikValues } from "formik";
import { FC, useEffect } from "react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

import BedAtAGlance from "./BedAtAGlance";
import BedStatusForm from "./BedStatusForm";

import { getBedStatus } from "../../../redux/bedStatus/action";
import bedStatusService from "../../../services/bedStatus";

import { RootState, useAppDispatch } from "../../../redux/store";
import { setLoadingAction } from "../../../redux/utils/actions";
import styles from "./BedStatus.module.scss";
import { bedStatusInitData, bedStatusValidationData } from "./utils";
import { userRoles } from "../../../constants/user";
const BedStatus: FC = (): JSX.Element => {
  const dispatch = useAppDispatch();

  const { role } = useSelector(
    (state: RootState) => state.auth.profileData.user
  );

  const { bedStatus } = useSelector((state: RootState) => state);

  const saveHandler = async (values: FormikValues) => {
    try {
      dispatch(setLoadingAction(true));
      // await bedStatusService.create( {
      //   total: +values.total || 0,
      //   available: +bedStatus.available,
      //   occupied: +bedStatus.occupied
      // }
      //   );

      const wardData = {
        total: +values.totalWard,
        available: +values.availableOnWard,
        occupied: +values.occupiedOnWard,
      };
      const icuData = {
        total: +values.totalIcu,
        available: +values.availableOnICU,
        occupied: +values.occupiedOnICU,
      };
      await bedStatusService.update(bedStatus.WARD.type, wardData);
      await bedStatusService.update(bedStatus.ICU.type, icuData);

      dispatch(getBedStatus());
      toast.success("Updated successfully");
      dispatch(setLoadingAction(false));
    } catch (error: any) {
      toast.error(error.response.data.msg);
      dispatch(setLoadingAction(false));
    }
  };

  useEffect(() => {
    const getData = async () => {
      try {
        dispatch(setLoadingAction(true));
        await dispatch(getBedStatus());
        dispatch(setLoadingAction(false));
      } catch {
        dispatch(setLoadingAction(false));
      }
    };
    getData();
  }, [dispatch]);

  return (
    <Formik
      enableReinitialize={true}
      initialValues={bedStatusInitData}
      validationSchema={bedStatusValidationData}
      validateOnBlur={true}
      validateOnChange={false}
      onSubmit={(values, { setSubmitting, validateForm, setErrors }) => {
        setSubmitting(true);
        saveHandler(values);
        setSubmitting(false);
      }}
    >
      {({ values, setFieldValue, resetForm, handleChange, handleSubmit }) => (
        <Form>
          <Box className={styles.bedStatusPage}>
            <BedAtAGlance />
            {
              (role === userRoles.STAFF || role === userRoles.SUPER_ADMIN) &&
              <Card className={`mg-b-24 ${styles.cardAvailability}`}>
              <div className={`text-center pd-y-20 ${styles.cardHeader}`}>
                <Typography
                  variant="h2"
                  component="h2"
                  className={`${styles.headingH2}`}
                  >
                  Update the bed availability
                </Typography>
              </div>
              <BedStatusForm />
            </Card>
                }
          </Box>
        </Form>
      )}
    </Formik>
  );
};

export default BedStatus;
